import { render, staticRenderFns } from "./IndemnityModalStep1.vue?vue&type=template&id=54a9c239&scoped=true"
import script from "./IndemnityModalStep1.vue?vue&type=script&lang=js"
export * from "./IndemnityModalStep1.vue?vue&type=script&lang=js"
import style0 from "./IndemnityModalStep1.vue?vue&type=style&index=0&id=54a9c239&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54a9c239",
  null
  
)

export default component.exports